import type { FC } from 'react'

import useTranslation from '@space-core/hooks/useTranslation'

import { Empty } from './moderationListEmptyStateStyles'
import type { ModerationListEmptyStateProps } from './types'

const ModerationListEmptyState: FC<ModerationListEmptyStateProps> = ({
  hide = false,
  isError = false
}) => {
  const { t } = useTranslation()
  if (hide) {
    return null
  }

  if (isError) {
    return (
      <Empty className='_d-flex _text-gray-900 _align-items-center _justify-content-center _w-full _pt-6'>
        {t('configuration_sidebar.members_and_permissions.list.error_state')}
      </Empty>
    )
  }

  return (
    <Empty className='_d-flex _text-gray-900 _align-items-center _justify-content-center _w-full _pt-6'>
      {t('configuration_sidebar.members_and_permissions.list.empty_state')}
    </Empty>
  )
}

export default ModerationListEmptyState
